import {useState} from "react";
import React from "react";
import {formatDate} from "../helpers/util";
import VismerKnappen from "../components/VismerKnappen"
import {withRouter, useHistory } from "react-router-dom";
import qs from "query-string";




const Indeks = (props) => {
    const hund = props.hund;
    const {hdIndekser: hd, ryggIndekser: rygg } = props;
    let label = "hd";
    if (hund.rase !== null && hund.rase.raseId !== null && hund.rase.raseId.substring(0, 3) === '148') {
        label = "ryg";
    }

    let history = useHistory();
    const parsed = qs.parse(decodeURI(props.location.search));
    if (parsed.indexLabel !== undefined) {
        label = parsed.indexLabel;
    }


    const renderTable = () => {
        switch (label) {
            case "ryg":
                return <Table indekser={rygg} />;
            case "hd":
                return <Table indekser={hd} />
            default:
                return null;
        }
    };

    const setLabel = (t) => {
        let params = parsed
        if (t !== label) {
            params.indexLabel = t;
        }
        delete params.stamLabel;
        delete params.query;
        delete params.antall;
        const currentPath = props.location.pathname;
        history.push(currentPath + "?" + qs.stringify(params));
    };

    const getClassNames = (t) => {
        return (label === t)
            ? "tabs-title tab-active"
            : "tabs-title";
    };

    return (
        <div>
            <div className="tab-container">
                <ul className="tree-options">
                    <li className={getClassNames('hd')} onClick={() => setLabel("hd")}>
                        <span>HD</span>
                    </li>
                    <li className={getClassNames('ryg')} onClick={() => setLabel("ryg")}>
                        <span>RYG</span>
                    </li>
                </ul>
            </div>
            <div className="tabs-panel is-active" >
                { renderTable() }
            </div>
        </div>
    );
};

const Table = (props) => {
    const indekser = props.indekser;

    const [resultaterVises, setResultaterVises] = useState(10)

    const rows = indekser.map((indeks) => (
        <Row key={indeks.id} indeks={indeks} />
    )).splice(0, resultaterVises);;

    return (
        <>
            <table className="table-indeks" cellSpacing="0" cellPadding="0">
                <thead>
                <tr>
                    <th className="text-left" width="60px">Dato</th>
                    <th className="text-right">Index tal</th>
                    <th className="text-right">Index sikkerhed</th>
                </tr>
                </thead>
                <tbody>
                { rows }
                </tbody>
            </table>
            <VismerKnappen
                total={indekser.length}
                maxStep="10"
                renderedAmount={resultaterVises}
                incrementer={setResultaterVises}
            />
        </>
    );
};

const Row = (props) => {
    const indeks = props.indeks;

    return (
        <tr>
            <td>{formatDate(indeks.dato)}</td>
            <td className="text-right">{indeks.tall}</td>
            <td className="text-right">{indeks.sikkerhet}</td>
        </tr>
    );
};


export default withRouter(Indeks);
